import 'video-react/dist/video-react.css';
import { Tag, Tags } from '../../../interfaces';
import { Prompt } from '../../atoms';

export const handleValueBool = (newValue: Tags, path: string) => {
  // cycle through true, false, undefined

  const target = newValue[path];
  if (target === true) {
    newValue[path] = false;
  } else if (target === false) {
    delete newValue[path];
  } else {
    newValue[path] = true;
  }
};

export const handleValueEnum = (newValue: Tags, path: string, idOfValue: string) => {
  if (newValue[path] === `ev:${idOfValue}`) {
    delete newValue[path];
  } else {
    newValue[path] = `ev:${idOfValue}`;
  }
};

export const handleValueInt = async (newValue: Tags, path: string, tag: Tag, idOfValue: string, evt?: any) => {
  const value = idOfValue || evt?.target?.value;

  // In case we're using a number, we can tell the code to ask for a value in a dialog
  // Thats useful when triggered from the dropdown
  if (value === undefined || value === 'prompt') {
    let question = 'Enter a number';
    if (tag.min_value !== undefined) {
      question += ` above ${tag.min_value}`;
    }
    if (tag.max_value !== undefined) {
      question += ` below ${tag.max_value}`;
    }

    const promptValue = await new Prompt(question, 'OK').promise;

    if (promptValue) {
      const num = parseInt(promptValue);
      if (num >= tag.min_value && num <= tag.max_value) {
        newValue[path] = num;
      }
    }
  } else {
    newValue[path] = parseInt(value, 10);
  }
};
